import { AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { clientsQueryKeys } from 'queries/clients/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { Client } from 'types/api/attacks/client'

function fetchClientsByIdentifier({
  queryKey: [endpoint, params]
}: QueryFunctionContext<ReturnType<typeof clientsQueryKeys.getByIdentifier>>) {
  if (!endpoint) {
    throw new AxiosError('No client identifier was provided to query')
  }

  const endpointWithParams = getEndpointWithParams(endpoint, params)

  return fetchQueryData<Client>(endpointWithParams)
}

export const useGetClientsByIdentifier = (
  identifier: string | undefined,
  options?: Omit<
    QueryObserverOptions<Client, AxiosError>,
    'queryFn' | 'queryKey'
  >
) => {
  const { currentTeamId: teamId } = useAuth()

  return useQuery<Client, AxiosError>({
    ...options,
    ...(identifier && {
      queryKey: clientsQueryKeys.getByIdentifier({ identifier, teamId })
    }),
    queryFn: fetchClientsByIdentifier
  })
}
